import { useEffect, useMemo, useState } from 'react';
import { LinearProgress, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FerramentasDaListagemCadastros } from '../../../shared/components/ferramentas-da-listagem/FerramentasDaListagemCadastros';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import { IListagemCredito, CreditoService } from '../../../shared/services/api/cadastros/CreditoService';
import { DialogoCreditos} from './DialogoCreditos';
import dayjs from 'dayjs';


export const ListagemDeCreditos: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const navigate = useNavigate();
  
  const [rows, setRows] = useState<IListagemCredito[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [detalheterceiro, setdetalheterceiro ] = useState<string>('novo');
  const [open, setOpen] = useState(false);
  

  const filter = useMemo(() => {
    return searchParams.get('filter') || '';
  }, [searchParams]);

  const page = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);
  
  const handleClose = (newValue?: string) => {
    setOpen(false);
  };
  
  useEffect(() => {
    setIsLoading(true);
  
    debounce(() => {
      CreditoService.getAll(page, filter )
        .then((result) => {
          setIsLoading(false);
          
          if (result instanceof Error) {
            alert(result.message);
          } else {
            setTotalCount(result.totalCount);
            setRows(result.data);
          }
        });
    });
  }, [page, filter, open]);
  
  
  return (
    <LayoutBaseDePagina
      titulo='Listagem de Créditos'
      barraDeFerramentas={
        <FerramentasDaListagemCadastros
          mostrarInputBusca
          textoDaBusca={filter}
          textoBotaoNovo='Adicionar'
          aoClicarEmNovo={() => {setdetalheterceiro('novo'); setOpen(true);}}
          aoMudarTextoDeBusca={texto => setSearchParams({ filter: texto, pagina: '1' }, { replace: true })}
          aoMudarTextoDoSelect={textoselect => setSearchParams({ filter: filter, tipo: textoselect, pagina: '1' }, { replace: true })}
          dadosSelecao={[
            { nameBD: 'descricao', descricao: 'Descrição' },
          ]}
        />
      }
    >
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Emissão</TableCell>
              <TableCell>Cliente</TableCell>
              <TableCell>Fábrica</TableCell>
              <TableCell>Valor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {rows.map(row => (
              <TableRow key={row.idcredito} 
                hover
                sx={{ cursor: 'pointer' }}
                onClick={() => {setdetalheterceiro(row.idcredito); setOpen(true);}}
              >
                <TableCell>{dayjs(row.emissao).format('DD/MM/YYYY')}</TableCell>
                <TableCell>{row.cliente}</TableCell>
                 <TableCell>{row.fabrica}</TableCell>
                 <TableCell>{row.valor}</TableCell>
              </TableRow>
            ))}
          </TableBody>
  
          {totalCount === 0 && !isLoading && (
            <caption>{Environment.LISTAGEM_VAZIA}</caption>
          )}
  
          <TableFooter>
            {isLoading && (
              <TableRow>
                <TableCell colSpan={3}>
                  <LinearProgress variant='indeterminate' />
                </TableCell>
              </TableRow>
            )}
            {(totalCount > 0 && totalCount > Environment.LIMITE_DE_LINHAS) && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Pagination
                    page={page}
                    count={Math.ceil(totalCount / Environment.LIMITE_DE_LINHAS)}
                    onChange={(_, newPage) => setSearchParams({ filter, pagina: newPage.toString() }, { replace: true })}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableFooter>
        </Table>
      </TableContainer>
      <DialogoCreditos
        id={detalheterceiro}
        value={''}  
        open={open} 
        onClose={handleClose}
        
      /> 
    </LayoutBaseDePagina>
  );
};